import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MemoryFolderAddComponent } from './memory-folder-add/memory-folder-add.component';
import { MemoryFolderListComponent } from './memory-list/memory-list.component';
import { MemoryListComponent } from './memory-details/memory-details.component';
import { PhotoVideoListComponent } from './photo-video-list/photo-video-list.component';


const routes: Routes = [
  { path: 'memory/:sub_event', component:  MemoryFolderListComponent },
  { path: 'memory-list', component: MemoryFolderListComponent },
  { path: 'memorys-list/:gallery_folder_id', component: MemoryListComponent },
  { path: 'add-memory-Folder/:sub_event', component: MemoryFolderAddComponent },
  { path: 'memory-photo-video/:flag/:gallery_folder_id', component: PhotoVideoListComponent }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MemoryRoutingModule { }
